import PropTypes from 'prop-types';

ChevronIcon.propTypes = {
    open: PropTypes.bool,
};

function ChevronIcon({open = false}) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#374151"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
                transform: open ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
                flexShrink: 0,
            }}
        >
            <polyline points="9 18 15 12 9 6"/>
        </svg>
    );
}

export default ChevronIcon;
